import { Controller } from '@hotwired/stimulus'

export default class SelectDeliveryMethodController extends Controller {
  static targets = ['submitButton', 'input'];

  connect() {
    this.updateSubmitButton();
  }

  updateSubmitButton() {
    const isAnyInputChecked = this.inputTargets.some(input => input.checked);
    this.submitButtonTarget.disabled = !isAnyInputChecked;
  }
}
